import { z } from "zod";

import { subscriptionSchema } from "@/features/billing/models";
import { productSchema } from "@/features/products/models";
import { Category, Price } from "@/shared/domains";
import { MEDICATION_REQUEST_STATUS } from "./constants";

export const medicationRequestSchema = z.object({
  id: z.number(),
  dateOfRequest: z.string(),
  status: z.enum(MEDICATION_REQUEST_STATUS),
  trackingNumber: z.string().nullable(),
  drugName: z.string().nullable(),
  dose: z.string().nullable(),
  supply: z.number().nullable(),
  resolution: z.string().nullable(),
  canMarkAsComplete: z.boolean(),
  product: productSchema.pick({ id: true, name: true, slug: true }).extend({
    category: Category.pick({ id: true, name: true, slug: true }),
  }),
  subscription: subscriptionSchema.pick({ id: true }),
});

export const pastMedicationRequestSchema = medicationRequestSchema.extend({
  product: medicationRequestSchema.shape.product.nullable(),
  subscription: medicationRequestSchema.shape.subscription.nullable(),
});

export const refillRequestSchema = z.object({
  id: z.number(),
  dateOfRequest: z.iso.datetime({ offset: true }),
  product: productSchema
    .pick({
      id: true,
      name: true,
      slug: true,
      description: true,
      disclaimer: true,
    })
    .extend({
      category: Category.pick({
        id: true,
        name: true,
        slug: true,
        description: true,
        isNew: true,
      }),
    }),
  price: Price.pick({ id: true, dose: true }),
});

export const availableRefillRequestSchema = z.object({
  product: medicationRequestSchema.shape.product,
  dosis: z.string().nullable(),
  isRefillable: z.boolean(),
  frequency: z.string(),
  hasUpcomingAppointment: z.boolean(),
  isSyncRequired: z.boolean(),
  hasPendingActions: z.boolean().nullish(),
});

export const deliveredMedicationSchema = z.object({
  id: refillRequestSchema.shape.id,
  delivered: z.boolean(),
});
